module.exports = __webpack_public_path__ + "img/vertical_3_2_3.609d9499.png";